module.exports = __webpack_public_path__ + "media/images/torchlit_tales-590ad23cee492b298422658f4435062a.png";